import BaseInputComponent from "basecomponents/BaseInputComponent";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";
import { connect } from "react-redux";

import { LoaderDots, Empty } from "../components/loaders";
import { InputField } from "../components/form";
import { LinkChildren } from "../components/button";

import {
  getClientArticles,
  updateArticleStatus,
  deleteClientArticle,
} from "../actions/articleActions";
import { getArticleStatus } from "../utils/packageUtils";
import { articles as articleStatus, packages as packageStatus } from "../config/statusConfig";
import { showModal } from "../utils/domUtils";

import ModalConfirmation from "modals/ModalConfirmation";

import { IArticle } from "../interfaces/IPackage";
class ClientDashboardArticles extends BaseInputComponent {
  state = {
    field: "",
  };

  idmodal_confirmation = "modal_confirm_delete_article";
  article = null;

  componentDidMount() {
    // @ts-ignore
    this.props.getClientArticles();
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.article.loading === true;
  }

  onUpdateArticleStatus = (article: IArticle, status: string) => {
    if (article.status === status) return;

    // @ts-ignore
    this.props.updateArticleStatus({
      id: article.id,
      status,
    });
  };

  onDeleteArticle = (article: IArticle) => {
    this.article = article;
    showModal(this.idmodal_confirmation);
  };
  onCancelDeleteArticle = () => {
    this.article = null;
  };
  onConfirmDeleteArticle = () => {
    if (!this.article) return;

    // @ts-ignore
    this.props.deleteClientArticle(this.article?.id);
    this.article = null;
  };

  getInputSearch = () => {
    const { field } = this.state;
    return (
      <div className="input-search mb-2">
        <InputField
          id="field"
          placeholder="Buscar..."
          value={field}
          onChange={this.onChangeTextInput}
        />
      </div>
    );
  };

  getArticleActions = (article: IArticle) => {
    const canEditForPackage = [packageStatus.empty, packageStatus.completing, null].includes(article.package_status)
    if (!canEditForPackage) return;

    const isArticleReceived = article.status === articleStatus.received

    return (
      <>
        {!isArticleReceived && (
          <>
            <a
              className="dropdown-item"
              href="#!"
              onClick={this.onUpdateArticleStatus.bind(
                this,
                article,
                articleStatus.disactive
              )}
            >
              <i className="feather icon-x mr-2"></i>Desactivar
            </a>
            <a
              className="dropdown-item"
              href="#!"
              onClick={this.onUpdateArticleStatus.bind(
                this,
                article,
                articleStatus.waiting
              )}
            >
              <i className="feather icon-check mr-2"></i>Activar
            </a>
          </>
        )}

        <LinkChildren
          extraClass="dropdown-item"
          href={`editar?id=${article.id}`}
        >
          <i className="feather icon-edit mr-2"></i>Editar
        </LinkChildren>
        {!isArticleReceived && (
          <a
            className="dropdown-item"
            href="#!"
            onClick={this.onDeleteArticle.bind(this, article)}
          >
            <i className="feather icon-trash mr-2"></i>Eliminar
          </a>
        )}
      </>
    )
  }

  getArticles() {
    const loading = this.isLoading();
    // @ts-ignore
    const articles: Array<IArticle> = this.props.article.elements;

    if (loading) {
      return <LoaderDots />;
    }
    // @ts-ignore
    else if (articles.length === 0) {
      return <Empty message="No hay articulos, intenga creando uno" />;
    }

    let articlesFiltered: Array<IArticle> = [];
    const filterWord = this.state.field.trim().toLocaleLowerCase();
    if (filterWord.length > 0) {
      articlesFiltered = articles.filter((a) => {
        if (a.name.toLocaleLowerCase().indexOf(filterWord) >= 0) {
          return true;
        }
        if (a.package_name?.toLocaleLowerCase().indexOf(filterWord) >= 0) {
          return true;
        }
        if (a.description?.toLocaleLowerCase().indexOf(filterWord) >= 0) {
          return true;
        }
        if (a.track_code?.toLocaleLowerCase().indexOf(filterWord) >= 0) {
          return true;
        }
        if (a.description?.toLocaleLowerCase().indexOf(filterWord) >= 0) {
          return true;
        }
        return false;
      });
    } else {
      articlesFiltered = articles;
    }

    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th></th>
              <th>ID</th>
              <th>Estado</th>
              <th>Nombre</th>
              <th>Tracking</th>
              <th>Paquete</th>
              <th>Descripcion</th>
            </tr>
          </thead>
          <tbody>
            {articlesFiltered.map((a) => (
              <tr key={uuid()}>
                <td>
                  <div className="dropdown">
                    <button
                      className="btn btn-link"
                      type="button"
                      id="dropdown_sample"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="feather icon-more-vertical-"></i>
                    </button>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdown_sample"
                    >
                      {this.getArticleActions(a)}
                    </div>
                  </div>
                </td>
                <td>{a.id}</td>
                <td>{getArticleStatus(a.status)}</td>
                <td>{a.name}</td>
                <td>{a.track_code}</td>
                <td>{a.package_name || "NA"}</td>
                <td>{a.description}</td>
              </tr>
            )
            )}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">Tabla de articulos</h5>
              </div>
              <div className="card-body">
                {this.getInputSearch()}
                {this.getArticles()}
              </div>
            </div>
          </div>
        </div>

        <ModalConfirmation
          modal_id={this.idmodal_confirmation}
          message="Este articulo dejara de formar parte de cualquier paquete y ya no sera esperado en caso de estar agregado en uno de ellos"
          question="Realmente desea eliminar este articulo?"
          onAccept={this.onConfirmDeleteArticle}
          onCancel={this.onCancelDeleteArticle}
        />
      </>
    );
  }
}

// @ts-ignore
ClientDashboardArticles.propTypes = {
  article: PropTypes.object.isRequired,
  getClientArticles: PropTypes.func.isRequired,
  updateArticleStatus: PropTypes.func.isRequired,
  deleteClientArticle: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  article: state.article,
});

export default connect(mapStateToProps, {
  getClientArticles,
  updateArticleStatus,
  deleteClientArticle,
})(ClientDashboardArticles);
